import React from 'react';
import { DownloadIcon } from 'lucide-react';
interface ExportButtonProps {
  onClick: () => void;
}
export function ExportButton({
  onClick
}: ExportButtonProps) {
  return <button onClick={onClick} className="fixed top-4 right-4 p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors shadow-lg z-10" aria-label="Export chat to PDF" title="Export Chat to PDF" data-id="element-55">
      <DownloadIcon className="w-5 h-5" data-id="element-56" />
    </button>;
}